export default __webpack_public_path__ + "static/media/conzia.ccfbaff6.png";